import administrativeIcon from "../assets/icons/administrative.svg";
import affiliatedCompanyIcon from "../assets/icons/affiliatedCompany.svg";
import commercialIcon from "../assets/icons/commercial.svg";
import contractIcon from "../assets/icons/contract.svg";
import companyIcon from "../assets/icons/company.svg";
import logisticIcon from "../assets/icons/logistic.svg";
import shippingIcon from "../assets/icons/shipping.svg";

export default {
  data() {
    return {
      administrativeIcon,
      affiliatedCompanyIcon,
      commercialIcon,
      companyIcon,
      contractIcon,
      logisticIcon,
      shippingIcon
    };
  }
};
